export default __webpack_public_path__ + "static/media/urgent.fb6bc5c1.svg";